import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Heading extends React.PureComponent {
    static propTypes = {
        appearance: PropTypes.oneOf(['display', 'h1', 'h2', 'h3', 'h4', 'h5', 'h5Caps', 'h6']),
        headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
        children: PropTypes.node.isRequired,
        className: PropTypes.string
    };

    static defaultProps = {
        appearance: 'h3',
        className: undefined
    }

    render() {
        const {
            appearance,
            headingLevel,
            children,
            className,
            ...rest
        } = this.props;

        const HeadingElement = `h${headingLevel}`;

        const style = cx(className, {
            'display': appearance === 'display',
            'h1': appearance === 'h1',
            'h2': appearance === 'h2',
            'h3': appearance === 'h3',
            'h4': appearance === 'h4',
            'h5-normal': appearance === 'h5',
            'h5': appearance === 'h5Caps',
            'h6': appearance === 'h6'
        });

        return (
            <HeadingElement
                data-component="Heading"
                className={style}
                {...rest}>
                {children}
            </HeadingElement>
        );
    }
}
